export const toolRoutes = [
  {
    path: '/tool/follow-up-monitoring',
    component: () => import('@/views/modules/tool/monitor/follow-up-monitoring'),
    meta: { name: '跟卖监控', keepAlive: true, permission: 'offerMonitor:view',modal:'工具'}
  },
  {
    path: '/tool/claim',
    component: () => import('@/views/modules/tool/claim/claim-new'),
    meta: { name: '索赔助手', keepAlive: true, permission: 'claim:view' ,modal:'工具'}
  },
  {
    path: '/tool/claim-detail',
    component: () => import('@/views/modules/tool/claim/claim-detail'),
    meta: { name: '索赔详情', keepAlive: true, permission: 'claim:view',modal:'工具' }
  },
  {
    path: '/tool/cloud-plugin-status',
    component: () => import('@/views/modules/tool/cloud-plugin-status/cloud-plugin-status'),
    meta: { name: '在线状态', keepAlive: true, permission: 'pluginOnlineStatus:view' ,modal:'工具'}
  },
  {
    path: '/tool/cloud-plugin-report',
    component: () => import('@/views/modules/tool/cloud-plugin-report/cloud-plugin-report'),
    meta: { name: '报表记录', keepAlive: true, permission: 'reportTaskRecord:view' ,modal:'工具'}
  },
  {
    path: '/tool/amazon-ad',
    component: () => import('@/views/modules/tool/amazon-ad/amazon-ad'),
    meta: { name: 'Amazon广告', keepAlive: true, permission: 'amazon-ad:view',modal:'工具'}
  }
];
